import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

export const usePermissions = () => {
  const { user } = useContext(AuthContext);

  const hasPermission = (pageKey) => {
    if (!user) return false;
    
    const effectivePermissions = user.effectivePermissions || user.access;
    return effectivePermissions?.pages?.[pageKey] === true;
  };

  const isReadOnly = () => {
    if (!user) return false;
    
    const effectivePermissions = user.effectivePermissions || user.access;
    return effectivePermissions?.readOnly === true;
  };

  const canAccess = (pageKey) => {
    return hasPermission(pageKey) && !isReadOnly();
  };

  const isAdmin = () => {
    return user?.role === 'Admin' || user?.role === 'SuperAdmin' || hasPermission('settings');
  };

  return {
    hasPermission,
    isReadOnly,
    canAccess,
    isAdmin,
    user
  };
};

export default usePermissions;
